module.exports = {
          srcSet: __webpack_public_path__ + "assets/721a9f1d64cfbf578d161c4f238bc287.jpg"+" 84w",
          images:[ {path: __webpack_public_path__ + "assets/721a9f1d64cfbf578d161c4f238bc287.jpg",width: 84,height: 84}],
          src: __webpack_public_path__ + "assets/721a9f1d64cfbf578d161c4f238bc287.jpg",
          toString:function(){return __webpack_public_path__ + "assets/721a9f1d64cfbf578d161c4f238bc287.jpg"},
          
          width: 84,
          height: 84
        }